<template>
  <div class="ContactPage">
    <div class="Contact_top">
      <h2>{{ $t("contact__title") }} <span>*</span></h2>
      <p>
        {{ $t("contact__description") }}
      </p>
    </div>

     <OurDestination />
    <!-- <div class="contact_form_wrapper">
      <input
        type="text"
        class="input_name"
        :placeholder="$t('hackathon.fullname')"
        @input="filterName"
        maxlength="16"
        v-model="form.name"
      />
      <input
        type="tel"
        class="input_tell"
        :placeholder="$t('hackathon.phone')"
        v-mask="'+998 ## ### ## ##'"
        v-model="form.phone"
        value="+998"
      />
      <button
        class="contact_send_btn"
        :disabled="!isFormValid"
        @click="sendToTelegram"
      >
      {{ $t("send__message") }}
      </button>
    </div>
    <div class="contact_map">
      <Maps />
    </div>
    <div class="contact_footer_text">
      <div class="shadow-overlay"></div>
      <Icons name="contactText" />
      <div class="popup_icon">
        <Icons name="popup_icon" />
      </div>
    </div> -->
  </div>
</template>
<script>
import Icons from "@/components/Template/Icons.vue";
import Maps from "@/components/Maps/MapComponent.vue";
import OurDestination from "@/components/OurDestination/OurDestination.vue";
import { showSuccess } from "@/Utils/Toast";
import { showError } from "@/Utils/Toast";
import { mask } from "vue-the-mask";

export default {
  components: {
    Maps,
    Icons,
    OurDestination,
  },
  directives: { mask },
  data() {
    return {
      form: {
        name: "",
        phone: "",
      },
    };
  },
  computed: {
    isFormValid() {
      return this.form.name && this.form.phone;
    },
  },
  methods: {
    async sendToTelegram() {
      const botToken = "7927115509:AAHCT7c7elCP-CqBJGB8WnlYxcQf4fXoPhk";
      const chatId = "1091223879";
      const message = `📝 Yangi so'rov: 
			
			👤 Ism: ${this.form.name} 
			📞 Telefon: ${this.form.phone}
			`;

      const url = `https://api.telegram.org/bot${botToken}/sendMessage`;
      const payload = {
        chat_id: chatId,
        text: message,
        parse_mode: "Markdown",
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        if (data.ok) {
          showSuccess("Ma'lumot yuborildi!");
          this.form.name = "";
          this.form.phone = "";
        } else {
          showError("Xatolik yuz berdi");
        }
      } catch (error) {
        console.error("Xatolik:", error);
        showError("Xatolik yuz berdi");
      }
    },
    filterName(event) {
      this.form.name = event.target.value.replace(/[^a-zA-Zа-яА-Яўғқҳʼ ]/g, "");
    },
    scrollToForm() {
      const mapSection = document.querySelector(".contact_footer_text");
      const popup = document.querySelector(".popup_icon");
      if (mapSection) {
        mapSection.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style>
.ContactPage {
  width: 100%;
  height: auto;
  background-color: #000000;
  padding: 70px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.Contact_top h2 {
  font-size: 69px;
  color: rgba(255, 255, 255, 1);
  font-weight: 500;
}
.Contact_top p {
  font-family: Manrope;
  font-weight: 400;
  font-size: 21px;
  color: rgba(255, 255, 255, 1);
  padding-right: 30px;
  margin-top: 10px;
}
.Contact_top {
  position: relative;
}
.Contact_top span {
  font-size: 69px;
  color: rgba(248, 218, 11, 1);
  font-weight: 600;
  margin-left: -10px;
}
@media (max-width: 768px) {
  .Contact_top h2 {
    font-size: 36px;
  }
  .Contact_top span {
    font-size: 36px;
    margin-left: -5px;
  }
  .Contact_top p {
    font-size: 16px;
    padding-right: 10px;
  }
  .ContactPage {
    padding: 40px 0 0 0;
    gap: 20px;
  }
}

</style>
